"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MusicDetailsViewModel = void 0;
const tsyringe_1 = require("tsyringe");
const BaseViewModel_1 = require("../../core/render/BaseViewModel");
const globalSymbols_1 = require("../../globalSymbols");
const SongPropertiesPanel_1 = require("../defaultPanels/SongPropertiesPanel");
const SongMetadata_1 = require("../../core/music/SongMetadata");
const HomePanel_1 = require("../defaultPanels/HomePanel");
let MusicDetailsViewModel = class MusicDetailsViewModel extends BaseViewModel_1.BaseViewModel {
    constructor(songManager, plugins, resourceManager) {
        super();
        this.songManager = songManager;
        this.plugins = plugins;
        this.resourceManager = resourceManager;
    }
    get songId() {
        return this.song.songId;
    }
    setSongId(value) {
        return __awaiter(this, void 0, void 0, function* () {
            this.song = yield this.songManager.getSongById(value);
            try {
                this.audioResource = yield this.resourceManager.getResource(this.song.audioStreamResourceId);
            }
            catch (error) {
                this.noAudioPresent = true;
            }
            this.loadedPluginPanels = [];
            this.loadedPlugins = [];
            for (let plugin of this.plugins.filter(filterPlugin => this.song.pluginsUsed.includes(filterPlugin.pluginName))) {
                this.loadedPlugins.push(plugin);
                if (plugin.useMusicDetailsPanels) {
                    for (let panel of plugin.getMusicDetailPanels()) {
                        panel.song = this.song;
                        this.loadedPluginPanels.push(panel);
                    }
                }
            }
            this.homePanel = new HomePanel_1.HomePanel(this);
            this.homePanel.song = this.song;
            this.songPropertiesPanel = new SongPropertiesPanel_1.SongProeprtiesPanel(this);
            this.songPropertiesPanel.song = this.song;
        });
    }
    updateSong(pluginsAdded, editComponents, updateFormData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.song.name = updateFormData.main.songName;
            this.song.artist = updateFormData.main.artist;
            this.song.audioStreamResourceId = updateFormData.main.audioResourceId;
            this.song.bannerImageUrl = updateFormData.main.songImageUrl;
            for (let newPlugin of pluginsAdded.map(pluginComponent => pluginComponent.basePlugin.pluginName)) {
                this.song.pluginsUsed.push(newPlugin);
            }
            for (let component of pluginsAdded) {
                let metadata = new SongMetadata_1.SongMetadata(component.basePlugin);
                if (!component.saveSong(updateFormData[component.basePlugin.pluginName], metadata)) {
                    throw Error(`${component.basePlugin.pluginName} failed to add metadata to the database. Aborting...`);
                }
                this.song.additionalMetadata.push(metadata);
            }
            for (let editComponent of editComponents) {
                if (!editComponent.saveSong(updateFormData[editComponent.basePlugin.pluginName], this.getSongMetadataForPlugin(editComponent.basePlugin.pluginName))) {
                    throw Error(`${editComponent.basePlugin.pluginName} failed to edit metadata to the database. Aborting...`);
                }
            }
            yield this.songManager.putSong(this.songId, this.song);
            this.songEdited();
            this.refreshSong();
        });
    }
    removePlugin(pluginName) {
        return __awaiter(this, void 0, void 0, function* () {
            this.song.additionalMetadata.splice(this.song.pluginsUsed.indexOf(pluginName), 1);
            this.song.pluginsUsed.splice(this.song.pluginsUsed.indexOf(pluginName), 1);
            yield this.songManager.putSong(this.songId, this.song);
            this.refreshSong();
        });
    }
    getSongMetadataForPlugin(pluginName) {
        return this.song.additionalMetadata.find(metadata => metadata.pluginName === pluginName);
    }
    get songName() {
        return this.song.name;
    }
    get songBannerImageUrl() {
        return this.song.bannerImageUrl;
    }
    audioResourceExists() {
        if (this.audioResource != null)
            return true;
        else
            return false;
    }
    getAudioResourceType() {
        return this.audioResource.resourceType;
    }
    getAudioResourceId() {
        return this.audioResource.resourceId;
    }
    getAudioResourceName() {
        return this.audioResource.resourceName;
    }
    getPluginByName(pluginName) {
        return this.loadedPlugins.find(plugin => plugin.pluginName === pluginName);
    }
    switchSong() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.songManager.switchSong(this.song.songId);
        });
    }
    deleteSong() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.songManager.deleteSongById(this.songId);
        });
    }
    getSongJson() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.songManager.songToJson(this.song.songId);
        });
    }
};
MusicDetailsViewModel = __decorate([
    tsyringe_1.injectable(),
    __param(0, tsyringe_1.inject(globalSymbols_1.TSongManager)), __param(1, tsyringe_1.injectAll(globalSymbols_1.TPlugins)), __param(2, tsyringe_1.inject(globalSymbols_1.TResourceManager)),
    __metadata("design:paramtypes", [Object, Array, Object])
], MusicDetailsViewModel);
exports.MusicDetailsViewModel = MusicDetailsViewModel;
//# sourceMappingURL=MusicDetailsViewModel.js.map